var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.JobType != 'RVP') ? _c('div', {
    attrs: {
      "id": "trackPaginate"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isPendingShipmentforDeliveryLoader
    },
    on: {
      "update:active": function($event) {
        _vm.isPendingShipmentforDeliveryLoader = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "b-table table table-bordered pending-for-delivery-ShipmentList"
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [(this.JobType != '') ? [_vm._m(0)] : [_vm._m(1)]], 2), _vm._v(" "), _c('tbody', [(_vm.pendingShipmentForDeliveryobj.length > 0) ? _vm._l((_vm.pendingShipmentForDeliveryobj), function(row) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(row.PendingDays))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.PendingDays))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ShippingID))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.TotalAttemptCount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ShipmentStatus))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CollectibleAmount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.OrderType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.IsSameDayDelivery))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.EDD))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.AddressType))])])
  }) : [(this.JobType != '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e()]], 2)]), _vm._v(" "), (_vm.totalPendingShipmentforDeliverycnt > 20) ? _c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  }) : _vm._e()], 1) : _c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isPendingShipmentforDeliveryLoader
    },
    on: {
      "update:active": function($event) {
        _vm.isPendingShipmentforDeliveryLoader = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "b-table table table-bordered ShipmentList",
    attrs: {
      "id": "shipmentListRvp"
    }
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkAll),
      expression: "checkAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkAll) ? _vm._i(_vm.checkAll, null) > -1 : (_vm.checkAll)
    },
    on: {
      "click": function($event) {
        return _vm.selectAllShipments($event)
      },
      "change": function($event) {
        var $$a = _vm.checkAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkAll = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("Pick Assign Date")]), _vm._v(" "), _c('th', [_vm._v("First Name")]), _vm._v(" "), _c('th', [_vm._v("Customer Address")]), _vm._v(" "), _c('th', [_vm._v("City")]), _vm._v(" "), _c('th', [_vm._v("Pincode")]), _vm._v(" "), _c('th', [_vm._v("Total Items")]), _vm._v(" "), _c('th', [_vm._v("Future Pickup Date")]), _vm._v(" "), _c('th', [_vm._v("Pending Days")]), _vm._v(" "), _c('th', [_vm._v("ReAttempt Count")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.pendingShipmentForDeliveryobj), function(row, index) {
    return _c('tr', {
      style: (row.IsPickupPriority == true ? _vm.styleObjectsp : ''),
      attrs: {
        "id": 'rvpTr' + row.ShippingId
      }
    }, [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedReverseShipmentData),
        expression: "selectedReverseShipmentData"
      }],
      staticStyle: {
        "font-size": "0.8em"
      },
      attrs: {
        "type": "checkbox",
        "name": 'selectedPickups' + index
      },
      domProps: {
        "value": row.ShippingId,
        "checked": Array.isArray(_vm.selectedReverseShipmentData) ? _vm._i(_vm.selectedReverseShipmentData, row.ShippingId) > -1 : (_vm.selectedReverseShipmentData)
      },
      on: {
        "click": function($event) {
          return _vm.PassSelectedData()
        },
        "change": function($event) {
          var $$a = _vm.selectedReverseShipmentData,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = row.ShippingId,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedReverseShipmentData = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedReverseShipmentData = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedReverseShipmentData = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ClientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ShippingId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(row.CreatedDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerFirstName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerAddress))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerCity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerPinCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.TotalItems))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(row.ReAttemptDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.PendingDays))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.TotalAttemptCount))]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "hidden",
        "id": 'CI' + row.ShippingId
      },
      domProps: {
        "value": row.ClientId
      }
    })])
  }), _vm._v(" "), (_vm.pendingShipmentForDeliveryobj.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Pending Days ")]), _vm._v(" "), _c('th', [_vm._v("Pending At Dest")]), _vm._v(" "), _c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("RP ShippingId")]), _vm._v(" "), _c('th', [_vm._v("Total Attempts")]), _vm._v(" "), _c('th', [_vm._v("Last Status")]), _vm._v(" "), _c('th', [_vm._v("Shipping Date")]), _vm._v(" "), _c('th', [_vm._v("Net Payment")]), _vm._v(" "), _c('th', [_vm._v("Order Type")]), _vm._v(" "), _c('th', [_vm._v("IsSame DayDelv.")]), _vm._v(" "), _c('th', [_vm._v("EDD")]), _vm._v(" "), _c('th', [_vm._v("Address Type")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v(" Please select JobType to view all shipments.! ")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-682b2650","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/common/pendingShipmentsforDelivery.vue
// module id = 1029
// module chunks = 1